import React from 'react';
import { Box, Typography } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

const errorBoundary = (WrappedComponent) => {
  class ErrorBoundaryWrapper extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }

    componentDidCatch(error) {
      console?.error(error);
      this.setState({ hasError: true });
    }

    render() {
      const { hasError } = this.state;
      if (hasError) {
        return (
          <Box sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
          >
            <ErrorOutline sx={{ fontSize: '30px', color: 'error.main' }} />
            <Typography sx={{ fontSize: '20px' }}>
              Oops! Something went wrong. Please refresh the page
            </Typography>
          </Box>
        );
      }
      return <WrappedComponent {...this.props} />;
    }
  }
  return ErrorBoundaryWrapper;
};

export default errorBoundary;
